// Step 24 — attention chips for the execution workspace.
//
// One chip per deterministic observation from
// `executionAttentionFlags`. Explicitly NOT a score — each chip is a
// distinct, explainable signal derived from status/counts the backend
// already returned.

import { executionAttentionFlags } from "./helpers";

export default function AIExecutionAttentionChips({
  actions,
  contracts,
  situation,
  now,
}) {
  const flags = executionAttentionFlags({ actions, contracts, situation, now });
  if (flags.length === 0) return null;
  return (
    <div className="qai-execution-attention-chips">
      {flags.map((f) => (
        <span
          key={f.kind}
          className="qai-execution-attention-chip"
          data-severity={f.severity}
          title={f.title}
        >
          {f.label}
        </span>
      ))}
    </div>
  );
}
